import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

import { appVersion } from '@atmi/core';
import { MenuItem, Menus } from '@atmi/core/models';

@Component({
  selector: 'app-sidenav',
  styleUrls: ['./sidenav.component.scss'],
  templateUrl: './sidenav.component.html',
})
export class SidenavComponent {
  @Input() menus: Menus = [];

  @Output() readonly clickMenu = new EventEmitter();

  constructor(
    private readonly router: Router,
    @Inject(appVersion) public readonly version: string,
  ) {
  }

  clickMenuItemHandler(m: MenuItem) {
    if (m.path) {
      this.router.navigateByUrl(m.path);
    } else if (m.action) {
      m.action();
    }

    this.clickMenu.emit();
  }
}
